import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class ExploitDBAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'exploitdb';
	getDetailEdbAsync(edb) {
		let request = {
			url: [this.getAPIUrl(), 'detail', edb].join('/')
		};
		return httpClient.getAsync(request);
	}
}

export default new ExploitDBAPI();